import * as React from 'react';
import { NotAvailablePopup } from '../../components/NotAvailablePopup';
import { useOffer } from '../../hooks';
import { useChatContext, useNotAvailablePopupContext } from '../../context';

export const NotAvailablePopupContainer: React.FC = () => {
  const { offerWithPopup, closeNotAvailablePopup } = useNotAvailablePopupContext();
  const { openChat } = useChatContext();
  const { id, user } = useOffer();

  const notAvailablePopupProps = React.useMemo(() => {
    const title = user?.agentAvailability?.title;
    const message = user?.agentAvailability?.message;

    if (offerWithPopup !== id || !title || !message) {
      return null;
    }

    return {
      onWriteMessage: () => {
        closeNotAvailablePopup();

        openChat();
      },
      title,
      message,
      chatsEnabled: !!user?.isChatsEnabled,
    };
  }, [closeNotAvailablePopup, id, offerWithPopup, openChat, user]);

  if (!notAvailablePopupProps) {
    return null;
  }

  return (
    <NotAvailablePopup
      onClose={closeNotAvailablePopup}
      onCallAnyway={closeNotAvailablePopup}
      {...notAvailablePopupProps}
    />
  );
};
